module.exports = __webpack_public_path__ + "static/media/header2.9537939c.png";